<template>
    <portal to="modals">
        <div v-if="showModal" class="fixed inset-0 flex items-center justify-center z-40">
            <transition
                    @before-leave="backdropLeaving = true"
                    @after-leave="backdropLeaving = false"
                    enter-active-class="transition-all duration-100 ease-out"
                    leave-active-class="transition-all duration-100 ease-in"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                    appear
            >
                <div v-if="showBackdrop">
                    <div class="absolute inset-0 bg-black opacity-50" @click="close"></div>
                </div>
            </transition>

            <transition
                    @before-leave="cardLeaving = true"
                    @after-leave="cardLeaving = false"
                    enter-active-class="transform transition-all duration-100 ease-out"
                    leave-active-class="transform transition-all duration-100 ease-in"
                    enter-class="opacity-0 scale-75"
                    enter-to-class="opacity-100 scale-100"
                    leave-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-75"
                    appear
            >
                <div v-if="showContent" class="relative modal-app z-50" :class="modalClass">
                    <div class="modal-header flex justify-between px-4" v-if="headerShow">
                        <span class="text text-2xl font-bold truncate" v-html="title"></span>
                        <button v-if="showCloseButton && !loading" @click="close" class="text-xl modal-close"><span class="icon-close"></span></button>
                    </div>
                    <div class="modal-body px-6 overflow-auto" :class="bodyClass">
                        <slot></slot>
                    </div>
                    <div class="modal-footer p-3" v-if="footerShow">
                        <btn v-if="removeButtonShow" @click="remove" class="mx-1 btn text-base text-center py-1 px-3"><span class="text-red-600" v-html="removeValue"></span></btn>
                        <btn v-if="okButtonShow" @click="ok" :name="submitName" :class="submitClass" class="regular-button" :loading="loading"><span class="text-white" v-html="submitValue"></span></btn>
                    </div>
                </div>

            </transition>
        </div>
    </portal>
</template>

<script>
    import Btn from './Btn'
    export default {
        name: "Modal",
        components: {Btn},
        props: {
            modalClass: {},
            bodyClass: {},
            value: {},
            scrollable: {
                default: true,
            },
            okButtonText: {
                default: 'Zapisz'
            },
            okButtonShow: {
                default: true
            },
            removeButtonShow: {
                default: false
            },
            headerShow: {
                default: true
            },
            showCloseButton: {
                default: true
            },
            footerShow: {
                default: true
            },
            title: {},
            submitValue: {
                default: 'Subscribe',
            },
            submitName: {
                default: 'subscribe',
            },
            submitClass: {
                default: 'bg-ultramarine text-white',
            },
            removeValue: {
                default: 'Remove',
            },
            loading: {}
        },
        data() {
            return {
                open: false,
                showModal: false,
                showBackdrop: false,
                showContent: false,
                backdropLeaving: false,
                cardLeaving: false,
            }
        },
        created() {
            const onEscape = (e) => {
                if (this.open && e.keyCode === 27) {
                    this.close()
                }
            }

            document.addEventListener('keydown', onEscape)

            this.$once('hook:destroyed', () => {
                document.removeEventListener('keydown', onEscape)
            })
        },
        watch: {
            value: {
                handler: function (newValue) {
                    if (newValue) {
                        this.show()
                    } else {
                        this.close()
                    }
                },
                immediate: true
            },
            leaving(newValue) {
                if (newValue === false) {
                    this.showModal = false
                }
            }
        },
        computed: {
            leaving() {
                return this.backdropLeaving || this.cardLeaving
            },
        },
        methods: {
            show() {
                this.showModal = true;
                this.showBackdrop = true;
                this.showContent = true;
                this.open = true;
                this.$emit('input', this.open);
                this.$emit('show');
            },
            close() {
                if (this.loading) {
                    return;
                }
                this.showBackdrop = false;
                this.showContent = false;
                this.open = false;
                this.$emit('input', this.open);
                this.$emit('close');

            },
            ok(event) {
                if (this.loading) {
                    return;
                }
                this.$emit('ok', event);
            },
            remove(event) {
                if (this.loading) {
                    return;
                }
                this.$emit('remove', event);
            }
        }
    }
</script>
